import React, { useState } from "react";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

/**
 * RollbackMembershipForm — Sub-sprint D-β-α.
 *
 * Form for `POST /admin/racket-lab/_ops/rollback-membership`. Server
 * accepts reason min 1; UI requires min 3 for parity with the audit
 * clarity contract. The form is wired by the parent into
 * `useDryRunApply`.
 */
export const RollbackMembershipForm = ({ value, onChange, disabled = false }) => {
  const t = useRacketLabAdminT();
  const [local, setLocal] = useState(value || { user_id: "", reason: "" });
  const update = (k, v) => {
    const next = { ...local, [k]: v };
    setLocal(next);
    onChange?.(next);
  };
  const reasonShort = (local.reason || "").trim().length < 3;

  return (
    <div data-testid="rl-ops-rollback-form" className="flex flex-col gap-3">
      <label className="flex flex-col gap-1 text-xs">
        <span className="font-medium text-slate-700">{t("ops.rollback.form.user_id_label")}</span>
        <input
          data-testid="rl-ops-rollback-user-id"
          value={local.user_id}
          onChange={(e) => update("user_id", e.target.value)}
          disabled={disabled}
          placeholder={t("ops.rollback.form.user_id_placeholder")}
          className="rounded-md border border-slate-300 px-2 py-1 text-sm font-mono"
        />
      </label>

      <label className="flex flex-col gap-1 text-xs">
        <span className="font-medium text-slate-700">
          {t("ops.rollback.form.reason_label")} <span className="text-rose-600">*</span>
        </span>
        <textarea
          data-testid="rl-ops-rollback-reason"
          value={local.reason}
          onChange={(e) => update("reason", e.target.value)}
          disabled={disabled}
          rows={3}
          placeholder={t("ops.rollback.form.reason_placeholder")}
          className={`rounded-md border px-2 py-1 text-sm ${reasonShort ? "border-rose-300" : "border-slate-300"}`}
        />
        {reasonShort && (
          <span className="text-[10px] text-rose-700">{t("ops.rollback.form.reason_short")}</span>
        )}
      </label>

      <p className="text-[10px] text-slate-500">
        {t("ops.rollback.form.footer_note")}
      </p>
    </div>
  );
};

export default RollbackMembershipForm;
